import getEnvironment from '@app/lib/environment';

const environment = getEnvironment();

export const firebaseClientConfig =
  environment === 'production'
    ? {
        // apiKey: process.env.FIREBASE_PRODUCTION_API_KEY,
        apiKey: 'AIzaSyDADB5OCoQbt7OxrveMcUywWSk5xpIJL_c',
        authDomain: 'zazu-production.firebaseapp.com',
        projectId: 'zazu-production',
        storageBucket: 'zazu-production.appspot.com',
        messagingSenderId: '63284183901',
        appId: '1:63284183901:web:e5801698c14e15d5195eb4',
        measurementId: 'G-6VL05Q0PFG',
      }
    : {
        apiKey: 'AIzaSyAxBe-G1GFE4lp6q-wLW8KyxT7LDFbymvU',
        // apiKey: process.env.FIREBASE_DEVELOP_API_KEY,
        authDomain: 'zazu-develop.firebaseapp.com',
        projectId: 'zazu-develop',
        storageBucket: 'zazu-develop.appspot.com',
        messagingSenderId: '90967042329',
        appId: '1:90967042329:web:effa385318f0e5c2413d88',
      };
